import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { I18nContext } from '../../I18n'

import styles from './Youtube.module.css'

Youtube.propTypes = {
  video: PropTypes.array
}

Frame.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string
}

export default function Youtube ({ video }) {
  const I18n = useContext(I18nContext)

  return (
    <div className={styles.root}>
      <div className={styles.heading}>
        {I18n.t('pages.index.youtube.title')}
      </div>

      {video.map((v, i) =>
        <Frame
          key={`${v.youtube_id}-${i}`}
          id={v.youtube_id}
          // key={`${v.video_id}-${i}`} // Обновлено на video_id
          // id={v.video_id} // Обновлено на video_id
          title={v.title}
          desc={dayjs.unix(v.created).locale(I18n.locale).format('D MMMM YYYY')}
        />
      )}
    </div>
  )
}

function Frame({ id, title, desc }) {
  const [active, setActive] = useState(false);

  const isYouTube = id && (id.startsWith('https://www.youtube.com') || id.length === 11);
  const isVimeo = id && id.startsWith('https://vimeo.com');
  const isRutube = id && id.startsWith('https://rutube.ru/');
  const isVkvideo = id && (id.startsWith('https://vk.com/') || id.startsWith('https://vkvideo.ru/')  ) ;

  

  // Функция для определения типа видео и получения embed-ссылки
  const getVideoEmbedSrc = (url) => {
    try {
      // const urlObj = new URL(url);
      // const hostname = urlObj.hostname;    

      // Rutube
      // if (hostname.includes('rutube.ru')) {
      //   const videoId = url.split('/').filter(Boolean).pop();
      //   return `https://rutube.ru/play/embed/${videoId}`;
      // }

      if (isRutube) {
        const videoId = url.split('/').filter(Boolean).pop();
        return `https://rutube.ru/play/embed/${videoId}`;
      }

      // VK Video
      // if (hostname.includes('vk.com') || hostname.includes('vkvideo.ru')) {     
      //   return null;
      // }

      if (isVkvideo) {
        // VK не поддерживает официальное встраивание через iframe
        // Можно попробовать использовать их виджет или показать ссылку
        return null;
      }

      // YouTube
      // if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
      //   const videoId = url.includes('youtu.be') 
      //     ? url.split('/').pop() 
      //     : new URLSearchParams(urlObj.search).get('v');
      //   return `https://www.youtube.com/embed/${videoId}`;
      // }

      if (isYouTube) {
        const videoId = url.includes('youtu.be') 
          ? url.split('/').pop() 
          : url;
        return `https://www.youtube.com/embed/${videoId}`;
      }     

      // Vimeo
      // if (hostname.includes('vimeo.com')) {
      //   const videoId = url.split('/').filter(Boolean).pop();
      //   return `https://player.vimeo.com/video/${videoId}`;
      // }

      if (isVimeo) {
        const videoId = url.split('/').filter(Boolean).pop();
        return `https://player.vimeo.com/video/${videoId}`;
      }


      // Прямая ссылка на видеофайл
      if (url.match(/\.(mp4|webm|ogg)$/i)) {
        return url;
      }

      return urlObj;
    } catch {
      return 'Invalid URL';
    }
  };

  // Функция для получения превью
  const getThumbnailSrc = (url) => {
    try {
      // const urlObj = new URL(url);
      // const hostname = urlObj.hostname;

      // if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
      //   const videoId = url.includes('youtu.be') 
      //     ? url.split('/').pop() 
      //     : new URLSearchParams(urlObj.search).get('v');
      //   return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
      // }

      if (isYouTube) {
        const videoId = url.includes('youtu.be') 
        ? url.split('/').pop() 
        : url;
        return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
      }

      // if (hostname.includes('vimeo.com')) {
      //   const videoId = url.split('/').filter(Boolean).pop();
      //   return `https://vumbnail.com/${videoId}.jpg`;
      // }


      if (isVimeo) {
        const videoId = url.split('/').filter(Boolean).pop();
        return `https://vumbnail.com/${videoId}.jpg`;
      }


      // if (hostname.includes('rutube.ru')) {
      //   const videoId = url.split('/').filter(Boolean).pop();
      //   return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
      // }
      

      // if (isRutube || isVkvideo) {
      //   const videoId = url.split('/').filter(Boolean).pop();
      //   return `https://rutube.ru/video/thumbnail/${videoId}/`;
      // }    


      if (isRutube || isVkvideo) {
        const parts = url.split('/');
        if (parts.length > 1) {
          const ownerId = parts[0].split('-')[1];
          const vkVideoId = parts[1];
          return `https://sun9-${Math.floor(Math.random() * 80) + 1}.userapi.com/impg/${vkVideoId}/video_${ownerId}_${vkVideoId}.jpg`;
        } else return parts;
      }    


      // Для других сервисов можно добавить аналогичные правила

      return '/images/videoplayer.png';
    } catch {
      return 'Invalid URL';
    }
  };

  const embedSrc = getVideoEmbedSrc(id);
  const thumbnailSrc = getThumbnailSrc(id);

  return (
    <div className={styles.video}>
      <div className={classNames(styles.youtube, { [styles.active]: active })} onClick={() => setActive(true)}>
        {!active ? (
          <div className={styles.img}>
            <img 
            src={thumbnailSrc} 
            alt={title} 
            onError={(e) => {
              e.target.src = '/images/videoplayer.png';
              e.target.onerror = null; // Предотвращаем зацикливание, если дефолтная картинка тоже не загрузится
            }}
            
            />
          </div>
        ) : (
          <>
            {embedSrc ? (
              <iframe
                src={`${embedSrc}?autoplay=1`}
                frameBorder="0"
                allowFullScreen
                allow="autoplay; encrypted-media"
                title={title}
              />
            ) : (
              <div className={styles.unsupported}>
                <p>Этот видеохостинг не поддерживает встраивание</p>
                <a href={id} target="_blank" rel="noopener noreferrer">
                  Открыть видео в новом окне
                </a>
              </div>
            )}
          </>
        )}
      </div>

      <div className={styles.title}>{title}</div>
      {/* <div className={styles.title}>{embedSrc}</div>
      <div className={styles.title}>{thumbnailSrc}</div> */}

      <div className={styles.date}>{desc}</div>
    </div>
  );
}
